import { ROUTE_ACCOUNT_EDIT_COMMUNICATION_PREFERENCES } from '@/constants/routes';
import setTitleFromLoader from '@/utils/routing/set-title';
import { RouteObject } from 'react-router-dom';
import Page from './edit-comm-preferences.page';

export const routeEditCommPreferences: RouteObject = {
  path: ROUTE_ACCOUNT_EDIT_COMMUNICATION_PREFERENCES,
  Component: Page,
  loader: setTitleFromLoader('Communication Preferences'),
};
